// extracted by mini-css-extract-plugin
export default {"tdCenter":"tdCenter__8hGRd","greenIcon":"greenIcon__vKEjl","redIcon":"redIcon__kRJri","line":"line__OmrzH"};